(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  function attachCheckboxListener() {
  var checkbox = document.getElementById('signup-checkbox-footer');
  var submitButton = document.getElementById('FooterSubscribe');

  if (checkbox && submitButton) {
    checkbox.removeEventListener('change', toggleSubmitButton);
    checkbox.addEventListener('change', toggleSubmitButton);

    submitButton.disabled = !checkbox.checked;
  }
}

function toggleSubmitButton() {
  var submitButton = document.getElementById('FooterSubscribe');
  if (submitButton) {
    submitButton.disabled = !this.checked;
  }
}

document.addEventListener('DOMContentLoaded', attachCheckboxListener);
document.addEventListener('shopify:section:select', attachCheckboxListener);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};

    this.setHeaderHeight();

    const marginDesktopValue = this.getAttribute('data-margin-desktop');
    // Fetch data-margin-desktop and calculate percentage
    this.marginDesktopPercentage = parseFloat(marginDesktopValue) || 2; 
    this.marginDesktopThreshold = this.marginDesktopPercentage*2 / 100; 

    const marginMobileValue = this.getAttribute('data-margin-mobile');
    this.marginMobilePercentage = parseFloat(marginMobileValue) || 2; 
    this.marginMobileThreshold = this.marginMobilePercentage / 300; 

    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    };

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollThreshold = 250; 
    const viewportWidth = window.innerWidth;
    let resetOffset;

    if (viewportWidth < 990) {
      resetOffset = window.innerHeight * this.marginMobileThreshold;
    } else {
      // Using desktop threshold
      resetOffset = window.innerHeight * this.marginDesktopThreshold;
    }
    
    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > (this.headerBounds.bottom + scrollThreshold)) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > (this.headerBounds.bottom + scrollThreshold)) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top + resetOffset) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden');
    this.header.classList.remove('shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
  }
}

customElements.define('sticky-header', StickyHeader);

  function initIntersectionObserver() {
  const headers = document.querySelectorAll('.enable-fixed-header-part--true.enable-header-full-width--false');

  if (!headers.length) return; // Ensure there are elements to observe

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');
        observer.unobserve(entry.target); 
      }
    });
  }, { threshold: 1 });

  headers.forEach(header => {
    observer.observe(header);
  });
}

initIntersectionObserver();

document.addEventListener('shopify:section:load', () => {
  initIntersectionObserver();
});

// Contact Support Functionality
class ContactSupport {
  constructor() {
    this.dayCheckboxes = document.querySelectorAll('[data-day-checkboxes] input[type="checkbox"]');
    this.timeFrom = document.querySelector('[data-time-from]');
    this.timeTo = document.querySelector('[data-time-to]');
    this.scheduleDisplay = document.querySelector('[data-schedule-display]');
    this.scheduleText = document.querySelector('[data-schedule-text]');
    this.headerScheduleDisplay = document.querySelector('[data-contact-schedule-display]');
    
    // Czech day abbreviations
    this.dayAbbreviations = {
      monday: 'Po',
      tuesday: 'Út',
      wednesday: 'St',
      thursday: 'Čt',
      friday: 'Pá',
      saturday: 'So',
      sunday: 'Ne'
    };
    
    this.dayOrder = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
    
    this.init();
  }

  init() {
    if (!this.dayCheckboxes.length || !this.timeFrom || !this.timeTo) return;

    // Add event listeners to all checkboxes
    this.dayCheckboxes.forEach(checkbox => {
      checkbox.addEventListener('change', () => {
        this.updateScheduleDisplay();
      });
    });

    // Add event listeners to time inputs
    this.timeFrom.addEventListener('change', () => {
      this.updateScheduleDisplay();
    });

    this.timeTo.addEventListener('change', () => {
      this.updateScheduleDisplay();
    });
  }

  getSelectedDays() {
    const selected = [];
    this.dayCheckboxes.forEach(checkbox => {
      if (checkbox.checked) {
        selected.push(checkbox.value);
      }
    });
    return selected.sort((a, b) => {
      return this.dayOrder.indexOf(a) - this.dayOrder.indexOf(b);
    });
  }

  groupConsecutiveDays(days) {
    if (days.length === 0) return [];
    
    const groups = [];
    let currentGroup = [days[0]];
    
    for (let i = 1; i < days.length; i++) {
      const currentIndex = this.dayOrder.indexOf(days[i]);
      const prevIndex = this.dayOrder.indexOf(days[i - 1]);
      
      if (currentIndex === prevIndex + 1) {
        // Consecutive day
        currentGroup.push(days[i]);
      } else {
        // Not consecutive, start new group
        groups.push(currentGroup);
        currentGroup = [days[i]];
      }
    }
    groups.push(currentGroup);
    
    return groups;
  }

  formatDayGroup(group) {
    if (group.length === 1) {
      return this.dayAbbreviations[group[0]];
    } else {
      const first = this.dayAbbreviations[group[0]];
      const last = this.dayAbbreviations[group[group.length - 1]];
      return `${first}-${last}`;
    }
  }

  formatTimeRange(fromTime, toTime) {
    if (!fromTime || !toTime) return '';
    
    // Format time as HH:MM (24-hour format)
    const formatTime = (time) => {
      if (!time) return '';
      // time input returns HH:MM format
      return time;
    };
    
    const from = formatTime(fromTime);
    const to = formatTime(toTime);
    
    if (from && to) {
      return `${from}-${to}`;
    }
    return '';
  }

  updateScheduleDisplay() {
    const selectedDays = this.getSelectedDays();
    const fromTime = this.timeFrom.value;
    const toTime = this.timeTo.value;
    
    if (selectedDays.length === 0 || !fromTime || !toTime) {
      if (this.scheduleDisplay) {
        this.scheduleDisplay.style.display = 'none';
      }
      return;
    }
    
    // Group consecutive days
    const dayGroups = this.groupConsecutiveDays(selectedDays);
    
    // Format day groups
    const formattedDays = dayGroups.map(group => this.formatDayGroup(group)).join(', ');
    
    // Format time range
    const timeRange = this.formatTimeRange(fromTime, toTime);
    
    // Combine and display
    const scheduleString = `${formattedDays} ${timeRange}`;
    
    // Update modal display
    if (this.scheduleText) {
      this.scheduleText.textContent = scheduleString;
    }
    
    if (this.scheduleDisplay) {
      this.scheduleDisplay.style.display = 'block';
    }
    
    // Update header display
    if (this.headerScheduleDisplay) {
      this.headerScheduleDisplay.textContent = scheduleString;
    }
  }
}

// Initialize contact support when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('[data-day-checkboxes]')) {
    new ContactSupport();
  }
});

// Re-initialize on section load (for theme editor)
document.addEventListener('shopify:section:load', () => {
  if (document.querySelector('[data-day-checkboxes]')) {
    new ContactSupport();
  }
});


  } catch(e) { console.error(e); }
})();
})();
